import request from '../../utils/request';

const PREFIX = '[CRM]';

export const EXPORT_ADVOCATES_REQUEST = `${PREFIX} EXPORT_ADVOCATES_REQUEST`;
export const EXPORT_ADVOCATES_SUCCESS = `${PREFIX} EXPORT_ADVOCATES_SUCCESS`;
export const EXPORT_ADVOCATES_FAILURE = `${PREFIX} EXPORT_ADVOCATES_FAILURE`;
export const EXPORT_ADVOCATES_SUCCESS_MESSAGE =
  'Your advocates export will be sent to your email shortly.';

const exportAdvocatesRequest = () => ({
  type: EXPORT_ADVOCATES_REQUEST,
});

const exportAdvocatesSuccess = payload => ({
  payload,
  type: EXPORT_ADVOCATES_SUCCESS,
});

const exportAdvocatesFailure = payload => ({
  payload,
  type: EXPORT_ADVOCATES_FAILURE,
});

export const exportAdvocates = uuid => dispatch => {
  dispatch(exportAdvocatesRequest());

  return request
    .post(`/v1/crm/${uuid}/export/advocates/`)
    .then(({ data }) => {
      dispatch(exportAdvocatesSuccess(data));

      return data;
    })
    .catch(({ response: { data } = {} }) => {
      dispatch(exportAdvocatesFailure(data));

      throw data;
    });
};

export const FETCH_SEARCHED_CONTACTS_REQUEST = `${PREFIX} FETCH_SEARCHED_CONTACTS_REQUEST`;
export const FETCH_SEARCHED_CONTACTS_SUCCESS = `${PREFIX} FETCH_SEARCHED_CONTACTS_SUCCESS`;
export const FETCH_SEARCHED_CONTACTS_FAILURE = `${PREFIX} FETCH_SEARCHED_CONTACTS_FAILURE`;

const fetchSearchedContactsRequest = () => ({
  type: FETCH_SEARCHED_CONTACTS_REQUEST,
});

const fetchSearchedContactsSuccess = payload => ({
  payload,
  type: FETCH_SEARCHED_CONTACTS_SUCCESS,
});

const fetchSearchedContactsFailure = payload => ({
  payload,
  type: FETCH_SEARCHED_CONTACTS_FAILURE,
});

export const fetchSearchedContacts = (phrase, organizationUuid) => dispatch => {
  dispatch(fetchSearchedContactsRequest());

  return request
    .get(`/v1/crm/${organizationUuid}/contacts/`, {
      params: {
        pageSize: 10,
        q: phrase,
      },
    })
    .then(({ data }) => {
      dispatch(fetchSearchedContactsSuccess(data));

      return data;
    })
    .catch(({ response: { data } = {} }) => {
      dispatch(fetchSearchedContactsFailure(data));

      throw data;
    });
};

export const RESET_SEARCHED_CONTACTS = `${PREFIX} RESET_SEARCHED_CONTACTS`;

export const resetSearchedContacts = () => ({
  type: RESET_SEARCHED_CONTACTS,
});
